import React from 'react';
import { motion } from 'framer-motion';

const AIPlatformSection = () => {
  return (
    <section className="py-20 bg-[#0f1629] text-white overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl md:text-3xl lg:text-4xl font-semibold text-center mb-16 leading-snug max-w-3xl mx-auto"
        >
          AI-powered customer engagement platform purpose-built for retailers
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex justify-center"
        >
          <img
            src="https://cdn.prod.website-files.com/620353a026ae70e21288308a/653fb0060c7eb910f2426e4d_Group%20427320077%20(1).svg"
            alt="AI Platform Flow"
            className="max-w-full w-[1000px]"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex justify-center mt-8"
        >
          <img
            src="https://cdn.prod.website-files.com/620353a026ae70e21288308a/653fb03a5aa5998ecbd37f61_Group%20427320078.svg"
            alt="AI Platform Details"
            className="max-w-full w-[1000px]"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default AIPlatformSection;
